import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useI18n } from "../../i18n/LanguageProvider";
import { Container, SectionLabel } from "../Container";
import { Reveal } from "../Reveal";

function Item({ item, index }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-black/10">
      <button
        type="button"
        data-testid={`faq-trigger-${index}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="focus-ring flex w-full items-center justify-between gap-6 py-6 text-left"
      >
        <span className="text-lg font-medium tracking-tight text-black md:text-xl">{item.q}</span>
        <span className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border border-black/10 transition-transform duration-300 ${open ? "rotate-45 bg-green text-white" : "text-black"}`}>
          <Plus strokeWidth={1.5} className="h-4 w-4" />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
          >
            <p className="max-w-2xl pb-6 text-base leading-relaxed text-black/55">{item.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export function Faq() {
  const { t } = useI18n();
  const items = t("faqx");

  return (
    <section id="faq" className="scroll-mt-24 py-32 md:py-40">
      <Container>
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-[0.8fr_1.2fr]">
          <div>
            <SectionLabel>{t("faq.label")}</SectionLabel>
            <Reveal>
              <h2 className="text-3xl font-semibold leading-tight tracking-tight text-black sm:text-4xl lg:text-5xl">
                {t("faq.title")}
              </h2>
            </Reveal>
          </div>
          <div>
            {items.map((item, i) => (
              <Item key={i} item={item} index={i} />
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
